/*eslint-env jquery*/
import React, { Component } from 'react'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import { memberService } from '../../_services/member.service'
import { classService } from '../../_services/class.service'
import Modal from 'react-responsive-modal'
import classStatuses from '../../_constants/classStatuses'
import ClassStatusesSelect from '../Shared/ClassStatusesSelect'
import DatePicker from '../Shared/DatePicker'
import NumberFormat from 'react-number-format'
import PriceInput from '../Shared/PriceInput'
import moment from 'moment-jalaali' // Notice here !
import ClassSelectForAdmin from '../Shared/ClassSelectForAdmin'

// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { Input } from 'antd'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import PieChart from 'react-minimal-pie-chart'
import memberStatuses from '../../_constants/memberStatuses'

import { config } from '../../config'
const base_url = config.apiBaseUrl

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} />}
  </SimpleValue>
)

function formatDefaultValue(e) {
  if (e !== '0001-01-01T00:00:00') {
    const momentValue = moment(e.split('T')[0], 'YYYY-MM-DD')
    if (momentValue.isValid()) {
      return momentValue.format('jYYYY/jMM/jDD')
    }
  }
}

class Attendance extends Component {
  constructor(props, context) {
    super(props, context)

    this.state = {
      data: [],
      loading: false,
      classInfoLoading: false,
      preRegisterLoading: false,
      classInfo: {},
      members: [],
      presentsCount: 0,
      registeredCount: 0,
      pageSize: 10,
      member: {}
    }
  }

  getClassInfo = id => {
    this.setState({
      classInfoLoading: true,
      classInfo: {},
      members: [],
      pageSize: 10
    })

    classService
      .getById(id)
      .then(res => {
        let class_ = res.data

        // console.log(class_);

        var dto = {}
        dto['pageSize'] = 10
        dto['page'] = 1
        dto['classId'] = id
        memberService
          .getAll(dto)
          .then(res2 => {
            let members_ = res2.data.result

            // console.log(members_);

            var pageSize =
              members_.length > this.state.pageSize
                ? this.state.pageSize
                : members_.length

            this.setState({
              classInfo: class_,
              members: members_,
              pageSize: pageSize,
              classInfoLoading: false
            })

            document.getElementById('nationalCode').focus()
          })
          .catch(error => {
            // console.log(error)
            this.setState({ classInfoLoading: false })
          })
      })
      .catch(error => {
        // console.log(error)
        this.setState({ classInfoLoading: false })
      })
  }

  handleSubmit = values => {
    this.setState({ preRegisterLoading: true })

    var member = this.state.members.filter(
      el => el.nationalCode === values.nationalCode
    )[0]

    if (member) {
      // console.log(member);
      this.handleChangeMemberStatus(member.id, 4)
      this.setState({ member: member, preRegisterLoading: false })
    } else {
      toastr.error(
        'عدم تطابق شرکت کننده',
        'شرکت کننده ای با کد ملی [' +
          values.nationalCode +
          '] در این کلاس ثبت نام نکرده است'
      )
      this.setState({ preRegisterLoading: false })
    }
  }

  handleChangeMemberStatus = (memberId, statusId) => {
    var dto = {}
    dto['id'] = memberId
    dto['memberStatus'] = statusId
    memberService
      .changeMemberStatus(dto)
      .then(res => {
        var members = this.state.members
        var index = members.findIndex(el => el.id === memberId)
        members[index].memberStatus = statusId

        this.setState({ members: members })

        // this.setState({ preRegisterLoading: false })
      })
      .catch(error => {
        // console.log(error)
        // this.setState({ preRegisterLoading: false })
      })
  }

  render() {
    const ValidationSchema = Yup.object().shape({
      nationalCode: Yup.string()
        .required('وارد کردن [کد ملی] الزامی است')
        .matches(/^[0-9]\d{9}$/, {
          message: 'کد ملی باید شامل 10 رقم باشد',
          excludeEmptyString: false
        }),
      classId: Yup.string()
        .trim()
        .required('کلاس')
      // status: Yup.string().trim().required('وضعیت'),
    })
    const {
      model,
      loading,
      data,
      classInfo,
      members,
      preRegisterLoading
    } = this.state
    return (
      !loading && (
        <div>
          <Formik
            initialValues={model}
            onSubmit={(values, { setSubmitting }) => {
              // console.log('props');
              this.handleSubmit(values)
            }}
            validationSchema={ValidationSchema}>
            {props => {
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                setFieldValue,
                handleSubmit,
                validateForm
              } = props
              return (
                <form onSubmit={handleSubmit}>
                  <div className="row sameHeight ">
                    <div className="col-md-6">
                      <div className="form-inline adminPanelBox">
                        <div className="col-md-12">
                          <label>کلاس</label>
                          <ClassSelectForAdmin
                            required
                            defaultValue={values.classId}
                            onChange={val => {
                              setFieldValue('classId', val)
                              this.getClassInfo(val)
                            }}
                          />
                          <ErrorMessage component={ErrorPopUp} name="classId" />
                        </div>

                        <div className="clearfix" />

                        <div className="col-md-12">
                          <label>کد ملی شرکت کننده</label>
                          <NumberFormat
                            format="##########"
                            isNumericString
                            allowNegative={false}
                            name="nationalCode"
                            id="nationalCode"
                            disabled={!values.classId}
                            onChange={e => {
                              setFieldValue('nationalCode', e.target.value)
                              // if (props.isValid) {
                              //   console.log("here");

                              // }
                            }}
                            // onChange={() => handleSubmit}
                            autoFocus={true}
                            className={
                              errors.nationalCode && touched.nationalCode
                                ? 'text-input numberFa rtl has-error'
                                : 'text-input numberFa rtl required'
                            }
                          />
                        </div>

                        <div className="clearfix" />

                        <div className="col-md-12">
                          <br />
                          <input type="hidden" name="id" value={values.id} />
                          <button
                            type="submit"
                            className={
                              'icon button submit-btn ' +
                              (preRegisterLoading ? 'isSubmitting' : '')
                            }
                            disabled={!values.classId}>
                            ثبت حاضری در کلاس
                          </button>
                        </div>
                        <div className="clearfix" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="">
                        {members.length > 0 && classInfo ? (
                          <div className="row">
                            <div className="col-md-6">
                              <div className="row">
                                <div className="col-md-12">
                                  <div class="card2 card2-stats">
                                    <div class="card2-header card2-header-primary card2-header-icon">
                                      <div class="card2-icon">
                                        <i class="mdi mdi-bullseye" />
                                      </div>
                                      <p class="card2-category rtl">
                                        تعداد کل ثبت نام ها
                                      </p>
                                      <h3 class="card2-title">
                                        {classInfo.registerCount}
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div class="card2 card2-stats">
                                    <div class="card2-header card2-header-success card2-header-icon">
                                      <div class="card2-icon">
                                        <i class="mdi mdi-check-all" />
                                      </div>
                                      <p class="card2-category rtl">
                                        تعداد حاضرین
                                      </p>
                                      <h3 class="card2-title">
                                        {
                                          members.filter(
                                            el => el.memberStatus === 4
                                          ).length
                                        }
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-12">
                                  <div class="card2 card2-stats">
                                    <div class="card2-header card2-header-info card2-header-icon">
                                      <div class="card2-icon">
                                        <i class="mdi mdi-close-outline" />
                                      </div>
                                      <p class="card2-category rtl">
                                        تعداد غایب ها
                                      </p>
                                      <h3 class="card2-title">
                                        {
                                          members.filter(
                                            el => el.memberStatus === 3
                                          ).length
                                        }
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <PieChart
                                data={[
                                  {
                                    title: 'تعداد حاضرها',
                                    value: members.filter(
                                      el => el.memberStatus === 4
                                    ).length,
                                    color: '#547EF6'
                                  },
                                  {
                                    title: 'تعداد غایب ها',
                                    value:
                                      classInfo.registerCount -
                                      members.filter(
                                        el => el.memberStatus === 4
                                      ).length,
                                    color: '#B3E4FB'
                                  }
                                ]}
                                labelPosition={140}
                                startAngle={180}
                                lineWidth={20}
                                label
                                labelStyle={{
                                  fontSize: '13px',
                                  fontFamily: 'IranSans',
                                  fill: '#121212'
                                }}
                                animate
                                style={{ width: '80%', margin: '0 auto' }}
                              />
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </div>
                  </div>

                  {members.length > 0 && classInfo ? (
                    <div className="row">
                      <div className="col-md-12">
                        <br />
                        <ReactTable
                          data={members}
                          // filterable

                          previousText="صفحه قبل"
                          nextText="صفحه بعد"
                          loadingText="در حال بارگذاری ..."
                          noDataText="نتیجه ای یافت نشد"
                          pageText="صفحه"
                          ofText="از"
                          rowsText="تعداد نمایش"
                          getTableProps={() => ({
                            style: { display: 'block' }
                          })}
                          defaultFilterMethod={(filter, row) =>
                            String(row[filter.id]) === filter.value
                          }
                          key={this.state.pageSize}
                          defaultPageSize={this.state.pageSize}
                          className="-striped -highlight"
                          showPagination={false}
                          getTableProps={() => ({
                            style: { display: 'block' }
                          })}
                          getTrProps={(state, rowInfo, column, instance) => {
                            const newSelected = Object.assign(
                              {},
                              this.state.selected
                            )
                            const selected = rowInfo
                              ? rowInfo.original.memberStatus === 4
                              : false
                            return {
                              style: {
                                backgroundColor:
                                  selected && 'rgba(80, 247, 168, .5)'
                                // color: selected && 'white',
                              }
                            }
                          }}
                          columns={[
                            {
                              Header: 'ردیف',
                              id: 'row',
                              maxWidth: 50,
                              filterable: false,
                              style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              },
                              className: 'numberFa',
                              Cell: row => {
                                return row.index + 1
                              }
                            },
                            {
                              Header: 'تصویر',
                              accessor: 'imagePath',
                              id: 'imagePath',
                              width: 100,
                              sortable: false,
                              filterable: false,
                              style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              },
                              Cell: row => (
                                <img
                                  style={{
                                    height: 70,
                                    width: 70,
                                    display: 'inline'
                                  }}
                                  alt=""
                                  src={base_url + row.original.imagePath}
                                />
                              )
                            },
                            {
                              Header: 'جنسیت',
                              accessor: 'gender',
                              id: 'gender',
                              style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              },
                              Cell: row =>
                                row.original.gender === 0 ? (
                                  <i className="mdi mdi-human-male mdi-24px" />
                                ) : (
                                  <i className="mdi mdi-human-female mdi-24px" />
                                ),
                              Filter: ({ onChange }) => (
                                <Input
                                  placeholder=""
                                  allowClear
                                  onChange={event =>
                                    onChange(event.target.value)
                                  }
                                />
                              )
                            },
                            {
                              Header: 'نام و نام خانوادگی',
                              id: 'fullName',
                              style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              },
                              accessor: el => el.firstName + el.lastName,
                              filterMethod: (filter, row) => {
                                const escapedStr = filter.value.toLowerCase()
                                const termsArr = escapedStr.split(' ')
                                const finalRegexStr = termsArr.reduce(
                                  (acc, curr, idx) =>
                                    acc + '(?=.*' + curr + ')',
                                  ''
                                )
                                const regex = new RegExp(finalRegexStr)
                                return regex.test(row[filter.id])
                              },
                              Cell: props => (
                                <span>
                                  {props.original.firstName}{' '}
                                  {props.original.lastName}
                                </span>
                              ),
                              Filter: ({ onChange }) => (
                                <Input
                                  placeholder=""
                                  allowClear
                                  onChange={event =>
                                    onChange(event.target.value)
                                  }
                                />
                              )
                            },
                            {
                              Header: 'کد ملی',
                              accessor: 'nationalCode',
                              id: 'nationalCode',
                              style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              },
                              filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, {
                                  keys: ['nationalCode']
                                }),
                              filterAll: true,
                              Filter: ({ onChange }) => (
                                <Input
                                  placeholder=""
                                  allowClear
                                  onChange={event =>
                                    onChange(event.target.value)
                                  }
                                />
                              )
                            },
                            {
                              Header: 'شماره موبایل',
                              accessor: 'mobile',
                              id: 'mobile',
                              style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              },
                              className: 'numberFa',
                              filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, {
                                  keys: ['mobile']
                                }),
                              filterAll: true,
                              Filter: ({ onChange }) => (
                                <Input
                                  placeholder=""
                                  allowClear
                                  onChange={event =>
                                    onChange(event.target.value)
                                  }
                                />
                              )
                            },
                            {
                              Header: 'نام اتحادیه',
                              accessor: 'union',
                              id: 'union',
                              style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              },
                              filterMethod: (filter, rows) =>
                                matchSorter(rows, filter.value, {
                                  keys: ['name']
                                }),
                              filterAll: true,
                              Filter: ({ onChange }) => (
                                <Input
                                  placeholder=""
                                  allowClear
                                  onChange={event =>
                                    onChange(event.target.value)
                                  }
                                />
                              ),
                              Cell: props => (
                                <span>{props.original.union.name}</span>
                              )
                            },
                            {
                              Header: 'وضعیت',
                              accessor: 'memberStatus',
                              id: 'memberStatus',
                              style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              },
                              Cell: props => (
                                <span>
                                  {
                                    memberStatuses.filter(
                                      el =>
                                        el.id === props.original.memberStatus
                                    )[0].name
                                  }
                                </span>
                              )
                            },
                            {
                              Header: 'حضور و غیاب',
                              accessor: 'id',
                              style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              },
                              sortable: false,
                              filterable: false,
                              Cell: row => (
                                <div>
                                  <a
                                    onClick={() =>
                                      this.handleChangeMemberStatus(
                                        row.original.id,
                                        4
                                      )
                                    }
                                    className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn"
                                    rel="tooltip"
                                    data-original-title="حاضر">
                                    <i className="mdi mdi-check-all" />
                                  </a>
                                  <a
                                    onClick={() =>
                                      this.handleChangeMemberStatus(
                                        row.original.id,
                                        3
                                      )
                                    }
                                    className="btn btn-sm btn-simple btn-info bmd-ripple bmd-flat-btn"
                                    rel="tooltip"
                                    data-original-title="غایب">
                                    <i className="mdi mdi-close-outline" />
                                  </a>
                                </div>
                              )
                            }
                          ]}
                        />
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </form>
              )
            }}
          </Formik>
        </div>
      )
    )
  }
}

export default Attendance
